import { render, staticRenderFns } from "./platformOfaddQuestionBank.vue?vue&type=template&id=1df91650"
import script from "./platformOfaddQuestionBank.vue?vue&type=script&lang=js"
export * from "./platformOfaddQuestionBank.vue?vue&type=script&lang=js"
import style0 from "./platformOfaddQuestionBank.vue?vue&type=style&index=0&id=1df91650&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports